<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Dashboard</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <dropdown class="mt-1">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="flex items-center group py-3">
                  <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Administración</div>
                </div>
                <icon class="w-5 h-5 group-hover:fill-yellow-500 fill-white focus:fill-yellow-500" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block px-6 py-2 hover:bg-yellow-500 hover:text-white" :href="route('empresas', $page.props.auth.user.id)">Empresa</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-yellow-500 hover:text-white" :href="route('contacts', $page.props.auth.user.id)">Pacientes</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-yellow-500 hover:text-white" :href="route('cuadros', $page.props.auth.user.id)">Médicos</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-yellow-500 hover:text-white" :href="route('cuadros', $page.props.auth.user.id)">Especialidades</inertia-link>
              </div>
            </dropdown>
    </div>   
    <div class="mb-4">
      <dropdown class="mt-1">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="flex items-center group py-3">
                  <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Boletería</div>
                </div>
                <icon class="w-5 h-5 group-hover:fill-yellow-500 fill-white focus:fill-yellow-500" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block px-6 py-2 hover:bg-yellow-500 hover:text-white" :href="route('cuadroscitas')">Citas</inertia-link>
                 </div>
            </dropdown>
    </div>    

    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Usuarios</div>
      </inertia-link>
    </div>     
   
            <div class="mb-4">
                  <inertia-link class="flex items-center group py-3" :href="route('diarios')">
        <icon name="store-front" class="w-4 h-4 mr-2" :class="isUrl('diarios') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('diarios') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Recepción</div>
      </inertia-link>
                 
                </div>
                
      <div v-if="$page.props.auth.user.rol !='Productor' && $page.props.auth.user.rol != 'Garita' && $page.props.auth.user.rol != 'Lavado'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('reportes')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('reportes') ? 'fill-white' : 'fill-yellow-400 group-hover:fill-white'" />
        <div :class="isUrl('reportes') ? 'text-yellow-300' : 'text-white group-hover:text-yellow-300'">Reportes</div>
      </inertia-link>
    </div>
  </div>
  
</template>

<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import VueTailwind from 'vue-tailwind'




export default {
  components: {
    Icon,
    Dropdown,
    VueTailwind,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
